import Vue from 'vue';
import VueRouter from 'vue-router';
import MainView from '@/views/MainView.vue';
import EmailView from '@/views/EmailView.vue';

Vue.use(VueRouter);

const Router = new VueRouter({
  mode: 'history',
  base: '/registration/',
  routes: [
    {
      path: '/',
      name: 'Signup',
      component: MainView,
    },
    {
      path: '/index.html',
      redirect: '/',
    },
    {
      path: '/verify/:token',
      name: 'Email',
      component: EmailView,
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});

export default Router;
